(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class SearchBarRotator extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.search-bar__input');
      this.field = this.querySelector('.search-bar__field');
      this.base = this.querySelector('.search-bar__rotator-base');
      this.accent = this.querySelector('.search-bar__rotator-accent');

      let examples = [];
      try {
        examples = JSON.parse(this.getAttribute('data-examples') || '[]');
      } catch (error) {
        examples = [];
      }
      this.examples = examples;
      this.index = 0;

      if (this.examples.length && this.base && this.accent) {
        this.showExample(0);
        this.timer = setInterval(() => {
          this.index = (this.index + 1) % this.examples.length;
          this.showExample(this.index);
        }, 3200);
      }

      if (this.input && this.field) {
        this.input.addEventListener('focus', () => {
          this.field.classList.add('is-active');
        });
        this.input.addEventListener('blur', () => {
          if (!this.input.value) this.field.classList.remove('is-active');
        });
        this.input.addEventListener('input', () => {
          this.field.classList.toggle('has-value', this.input.value.length > 0);
        });
      }
    }

    showExample(i) {
      const example = this.examples[i];
      if (!example) return;
      this.base.textContent = example[0];
      this.accent.textContent = '« ' + example[1] + ' »';
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }
  }

  customElements.define('search-bar-rotator', SearchBarRotator);

  (function(){var q=window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');function i(){document.querySelectorAll('.header-wrapper').forEach(function(h){var e=Array.prototype.slice.call(h.querySelectorAll('.header__inline-menu > ul > li > header-menu')).map(function(m){return{l:m.closest('li'),d:m.querySelector('details'),t:null}}).filter(function(x){return x.l&&x.d});e.forEach(function(n){n.l.addEventListener('mouseenter',function(){if(!q.matches)return;clearTimeout(n.t);e.forEach(function(x){if(x.d!==n.d&&x.d.open)x.d.open=false});if(!n.d.open)n.d.open=true});n.l.addEventListener('mouseleave',function(){if(!q.matches)return;n.t=setTimeout(function(){n.d.open=false},150)})})})}if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",i);else i()})();

  /* Ajout 2026-10-15 : un clic n'importe où sur la ligne d'un item de mega-menu (pas seulement sur le libellé) doit naviguer vers sa page, sauf un clic sur le chevron qui doit garder son rôle d'ouverture/fermeture. On écoute donc le <summary> entier plutôt que le seul <a> interne (dont la zone cliquable réelle est plus étroite que la ligne visible) pour rester fiable quel que soit l'endroit exact du clic. stopPropagation() seul ne suffit pas pour bloquer le toggle natif de <summary> : on empêche explicitement l'action par défaut et on navigue nous-mêmes (en laissant les ouvertures dans un nouvel onglet, clic molette, etc. suivre leur cours normal). */
  (function(){function i(){document.querySelectorAll('summary.mega-menu__top-level-summary').forEach(function(s){s.addEventListener('click',function(e){if(e.defaultPrevented||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;if(e.target.closest('.mega-menu__caret-zone'))return;var url=s.getAttribute('data-menu-url');if(!url)return;e.preventDefault();e.stopPropagation();window.location.href=url;},false);})}if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",i);else i()})();

  } catch(e) { console.error(e); }
})();
})();
